import type { FragmentOf } from '@/utilities/gql';
import { gql } from '@/utilities/gql';

export const FAIR_VALUE_HISTOGRAM_COMPANY_FRAGMENT = gql(`
  fragment FairValueHistogramCompanyFields on Company @_unmask {
    data {
      currencyInfo
    }
    myValuation {
      fairValue
    }
    analysisValue {
      lastSharePrice
    }
    valuationHistogram {
      count
      min
      max
      buckets {
        min
        max
        count
      }
    }
  }
`);

export type FairValueHistogramCompanyFragment = FragmentOf<
  typeof FAIR_VALUE_HISTOGRAM_COMPANY_FRAGMENT
>;

export type FairValueHistogramBucket =
  FairValueHistogramCompanyFragment['valuationHistogram']['buckets'][number];
